const customSelectors = {
  allLinks: document.querySelectorAll('[href="#get_your_setup"]'),
  getYourSeup: document.querySelector('#get_your_setup'),
  headerbar: document.getElementById('shopify-section-header'),
  cartDrawerClose: document.querySelector('[href="#close-cart"]')
};
class customJS {
    constructor() {
      if(customSelectors.allLinks){
            for (var i = 0 ; i < customSelectors.allLinks.length; i++) {
                customSelectors.allLinks[i].addEventListener('click', (event)=>{
                    event.preventDefault();
                    window.scrollTo({ top: customSelectors.getYourSeup.offsetTop-130, behavior: 'smooth' });                  
                    event.preventDefault();
                });
            }
        }
        if(window.location.href.includes('/#get_your_setup')){
            window.scrollTo({ top: customSelectors.getYourSeup.offsetTop, behavior: 'smooth' });
            history.replaceState && history.replaceState(
                null, '', location.pathname + location.search.replace(/[\?&]message=[^&]+/, '').replace(/^&/, '?')
            );
        }
        // setTimeout(() => {
        //     if(document.getElementById('trigger-addtocart')){
        //         document.getElementById('trigger-addtocart').addEventListener('click', (event)=>{
        //             document.getElementById('needtotrigger').click();
        //         });
        //     }
        // },2000);
    }
}

function emptycartlinkClick(event){
    if(window.globalVariables.template == 'index'){            
            window.scrollTo({ top: customSelectors.getYourSeup.offsetTop, behavior: 'smooth' });
            document.querySelector('[href="#close-cart"]').click();                                      
    }
    else{
        window.location.href="/#get_your_setup";
    }     
}

typeof customJS !== 'undefined' && new customJS();
